import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem
} from 'src/hooks/useLocalStorage';

const PROXY_SESSION_KEY = 'proxy-session';

export type ProxySession = {
  returnUrl: string;
  role?: string;
  reviewId?: string;
  submissionId?: string;
};

export const storeProxySession = (session: ProxySession) =>
  setLocalStorageItem(PROXY_SESSION_KEY, session);

export const getProxySession = () =>
  getLocalStorageItem<ProxySession>(PROXY_SESSION_KEY);

export const clearProxySession = () =>
  removeLocalStorageItem(PROXY_SESSION_KEY);
